/**
 * Stops video/iframe playback when the video popup (tingle) is closed.
 * Load this after video-popup.js. Does not modify video-popup.js.
 */
(function () {
  function stopMediaInModal(modalBoxContent) {
    if (!modalBoxContent) return
    var video = modalBoxContent.querySelector('video')
    if (video) {
      video.pause()
      video.currentTime = 0
    }
    var iframes = modalBoxContent.querySelectorAll('iframe')
    iframes.forEach(function (iframe) {
      iframe.src = 'about:blank'
    })
  }

  function patchVideoPopup() {
    if (typeof videoPopup === 'undefined') return
    var original = videoPopup.initPopup
    if (!original) return
    videoPopup.initPopup = function (content, text) {
      var self = this
      var getScrollBarWidth = (function () {
        var scrollDiv
        return function init() {
          scrollDiv = document.createElement('div')
          scrollDiv.style.cssText = 'width:100px;height:100px;overflow:scroll;position:absolute;top:-9999px'
          document.body.appendChild(scrollDiv)
          var w = scrollDiv.offsetWidth - scrollDiv.clientWidth
          document.body.removeChild(scrollDiv)
          return w
        }
      })()
      var root = document.documentElement
      self.modal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'button', 'escape'],
        cssClass: ['video-popup'],
        onOpen: function () {
          document.documentElement.classList.add('open-popup')
          root.style.setProperty('padding-right', getScrollBarWidth() + 'px')
        },
        onClose: function () {
          document.documentElement.classList.remove('open-popup')
          root.style.removeProperty('padding-right')
        },
        beforeClose: function () {
          stopMediaInModal(this.modalBoxContent)
          document.documentElement.classList.remove('open-popup')
          root.style.removeProperty('padding-right')
          return true
        }
      })
      self.modal.setHeader = function (content) {
        var popup_content = this.modalBoxContent
        var popup_header = document.createElement('div')
        popup_header.classList.add('tingle-modal-box__header')
        popup_header.innerHTML = content
        var parentElement = popup_content.parentNode
        parentElement.insertBefore(popup_header, popup_content)
      }
      if (text) {
        self.modal.setHeader(text)
      }
      self.modal.setContent(content)
      self.modal.open()
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchVideoPopup)
  } else {
    patchVideoPopup()
  }
})()
